import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  Button,
  Typography,
  Slider,
  Checkbox,
} from "@mui/material";
import { fontFamily, fontWeight } from "@mui/system";
import React, { useEffect, useState } from "react";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { motion, AnimatePresence } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import { BsCheck } from "react-icons/bs";

import http from "../HttpAxios";
import config from "../config.json";
import { useDispatch } from "react-redux";
import { addFilter } from "../redux/ProductsFilter/ProductsFilterReducer";
import { ChangeProductGridDisplay } from "../redux/UI/UIReducer";
const FilterButton = styled((props) => (
  <Button variant="outlined" {...props}>
    {props.children}
  </Button>
))(({ theme }) => ({
  width: "30%",
  height: "100%",
  // marginTop:theme.spacing(2),
  border: "1px solid #878987",
  color: "#878987",
  fontFamily: "lato,sans-serif",
  fontWeight: "800",
  fontSize: "14px",
  "&:hover": {
    color: "white",
    background: "#b59677",
    borderColor: "#b59677",
  },
}));
const StyledMenuItem = styled((props) => (
  <MenuItem {...props}>{props.children}</MenuItem>
))(({ theme }) => ({
  "&.MuiMenuItem-root": {
    color: "#878987",
  },
  "&.MuiMenuItem-root:hover": {
    color: "#b59677",
  },
}));

const DisplayBox = styled((props) => {
  const displayGrid = [
    {
      straps: [
        <>
          <span></span>
          <span></span>
          <span></span>
        </>,
      ],
      value: 1,
    },
    {
      straps: [
        <>
          <span></span>
          <span></span>
        </>,
      ],
      value: 2,
    },
    {
      straps: [
        <>
          <span></span>
          <span></span>
          <span></span>
        </>,
      ],
      value: 3,
    },
    {
      straps: [
        <>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </>,
      ],
      value: 4,
    },
    {
      straps: [
        <>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </>,
      ],
      value: 5,
    },
    {
      straps: [
        <>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </>,
      ],
      value: 6,
    },
  ];
  return (
    <Box {...props}>
      {displayGrid.map((item) => (
        <FormControlLabel
          sx={{
            marginRight: 0,
            "&.MuiFormControlLabel-root": { margin: 0 },
            "& .MuiFormControlLabel-label div": props.gridDisplay ===
              item.value && {
              borderColor: "black !important",
              "& span": {
                background: "black !important",
              },
            },
          }}
          control={
            <input
              type="radio"
              hidden
              id="column_Grid_display"
              name="gridDisplay"
              value={"column"}
              onChange={() => props.handleChangeDisplay(item.value)}
            />
          }
          label={<Box className="display_div">{[...item.straps]}</Box>}
        ></FormControlLabel>
      ))}
    </Box>
  );
})(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: 12,
  "& .MuiFormControlLabel-root .MuiFormControlLabel-label .display_div": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    width: "auto",
    height: "24px",
    border: "1px solid gray",
    gap: 3,
    padding: 3,
    cursor: "pointer",
    transition: ".6s",
    span: {
      background: "gray",
      transition: ".6s",
      width: "8px",
      height: "100%",
    },
  },
  "& .MuiFormControlLabel-root .MuiFormControlLabel-label .display_div:hover": {
    borderColor: "black",
    "& span": {
      background: "black",
    },
  },
  "& .MuiFormControlLabel-root:nth-child(1) .MuiFormControlLabel-label .display_div":
    {
      flexDirection: "column",
      gap: 2,
      padding: 2,
      "& span": {
        width: "23px",
        height: "100%",
      },
    },
}));

const ToolbarBox = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    height: "100px",
    width: "100%",
    alignItems: "center",
  })
);

const FilterDiv = styled((props) => (
  <Box
    className="filterWrapper"
    component={motion.div}
    animate={{ height: "400px" }}
    initial={{ height: 0 }}
    transition={{ duration: "0.5" }}
    exit={{ height: 0 }}
    {...props}
  >
    <Box className="filterBody">
      <Box>
        <Typography variant={"h6"}>By Title</Typography>
        <TextField
          id=""
          label=""
          value={props.searchField}
          onChange={(e) => props.setFilterSearch(e.target.value)}
          placeholder="search for product title"
        />
      </Box>
      <Box>
        <Typography variant={"h6"}>By Price</Typography>
        <Slider
          sx={{
            "& .MuiSlider-thumb": {
              borderRadius: 0,
              width: "5px",
              color: "#b59677",
            },
            "& .MuiSlider-track": { color: "#b59677" },
            "& .MuiSlider-rail": { color: "rgb(162 162 162)" },
          }}
          getAriaLabel={() => "Minimum distance shift"}
          value={props.pricesSlider}
          onChange={(e, newValue) => props.setPricesSlider(newValue)}
          valueLabelDisplay="auto"
          // getAriaValueText={valuetext}
        />
        <Typography variant={"body1"} sx={{ marginTop: 2 }}>
          <span style={{ color: "#878987" }}>Prices:</span> $
          {props.pricesSlider[0]} — ${props.pricesSlider[1]}
        </Typography>
      </Box>
      <Box>
        <Typography variant={"h6"} sx={{ marginBottom: "20px !important" }}>
          By Size
        </Typography>
        <Box
          className="sizes"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "start",
            "& .MuiFormControlLabel-root": {
              // alignItems:'flex-start',
              paddingTop: 0,
            },
            "& .MuiTypography-root": {
              fontFamily: "lato,sans-serif",
              fontSize: "14px",
            },
            "& .MuiCheckbox-root": {
              color: "#C4C4C4",
              // paddingTop:0,
            },
          }}
        >
          {props.sizes.map((item) => (
            <FormControlLabel
              label={item.label}
              labelPlacement="end"
              control={
                <Checkbox
                  size="small"
                  value={item.value}
                  checked={props.SizeCheckbox[item.value]}
                  onChange={(e) =>
                    props.setSizeCheckbox((prev) => ({
                      ...prev,
                      [item.value]: e.target.checked,
                    }))
                  }
                />
              }
            />
          ))}
        </Box>
      </Box>
      <Box>
        <Typography variant={"h6"} sx={{ marginBottom: "20px !important" }}>
          By Color
        </Typography>
        <Box
          className="sizes"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "start",
            overflowY: "scroll",
            "& .MuiFormControlLabel-root": {
              paddingTop: 0,
            },
            "& .MuiTypography-root": {
              fontFamily: "lato,sans-serif",
              fontSize: "14px",
            },
            "& .MuiCheckbox-root": {
              color: "#C4C4C4",
              marginLeft: "4px",

              // paddingTop:0,
            },
            "& .MuiBox-root": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        >
          {props.colors.map((item) => (
            <FormControlLabel
              label={item.label}
              labelPlacement="end"
              control={
                <Checkbox
                  icon={
                    <Box
                      sx={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "50%",
                        background: item.value,
                      }}
                    ></Box>
                  }
                  checkedIcon={
                    <Box
                      sx={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "50%",
                        background: item.value,
                      }}
                    >
                      <BsCheck style={{ color: "white", fontSize: "24px" }} />
                    </Box>
                  }
                  size="small"
                  value={item.value}
                  checked={props.ColorsCheckbox[item.value]}
                  onChange={(e) =>
                    props.setColorsCheckbox((prev) => ({
                      ...prev,
                      [item.value]: e.target.checked,
                    }))
                  }
                />
              }
            />
          ))}
        </Box>
      </Box>
    </Box>
    <Box className="filterFooter">
      <FilterButton onClick={props.handleFilter}>Filter</FilterButton>
    </Box>
  </Box>
))(({ theme }) => ({
  // width:'80%',
  "&": {
    justifyContent: "center",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    gap: theme.spacing(4),
    borderRadius: "10px",
    boxShadow: " 0px 0px 9px 7px rgba(231,230,230,0.6);",
    "& .filterFooter": {
      width: "100%",
      display: "flex",
      height: "30%",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      padding: `0 ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,

      "& button": {
        overflow: "hidden",
      },
    },
    "& .filterBody": {
      padding: `${theme.spacing(4)} ${theme.spacing(4)} 0 ${theme.spacing(4)}`,
      display: "flex",
      flexDirection: "row",
      overflow: "hidden",
      width: "100%",
      gap: theme.spacing(4),
      "& > div": {
        width: "25%",
        display: "flex",
        flexDirection: "column",
        // padding:theme.spacing(4),

        "& h6": {
          fontFamily: "Montserrat,sans-serif",
          // borderBottom:'4px solid #4D5959',
          // borderWidth:'60%',
          position: "relative",
          letterSpacing: "1px",
          fontSize: "18px",
          color: "#4D5959",
          marginBottom: theme.spacing(5),
        },
        "& h6:after": {
          content: "''",
          position: "absolute",
          background: "#4D5959",
          top: "100%",
          left: 0,
          height: "2px",
          width: "30%",
        },
        "& .MuiInputBase-input": {
          height: "10px",
          fontFamily: "lato,sans-serif",
          fontSize: "15px",
        },
      },
    },
  },
}));

const ClothingFilter = () => {
  const dispatch = useDispatch();
  const [gridDisplay, setgridDisplay] = useState(3);
  const [searchSort, setSearchSort] = useState("featured");
  const [filterDivOpen, setFilterDivOpen] = useState(false);
  const [filterSearch, setFilterSearch] = useState("");
  const [pricesSlider, setPricesSlider] = useState([20, 37]);
  const [SizeCheckbox, setSizeCheckbox] = useState({
    l: false,
    m: false,
    s: false,
    xl: false,
    xs: false,
  });
  const [ColorsCheckbox, setColorsCheckbox] = useState();
  const handleFilter = () => {
    dispatch(
      addFilter({
        title: filterSearch,
        price: pricesSlider,
        size: SizeCheckbox,
        color: ColorsCheckbox,
      })
    );
  };
  const handleChangeDisplay = (value) => {
    setgridDisplay(value);
    dispatch(ChangeProductGridDisplay(value));
  };
  useEffect(() => {
    const colorsItems = {};
    colors.forEach((element) => {
      colorsItems[element.value] = false;
    });
    setColorsCheckbox(colorsItems);
  }, []);
  //request
  // useEffect(() => {
  //     http.get(config.routes_get_Sizes_colors_filter).then(({data})=>{
  //         setSizeCheckbox(data.sizes);
  //         // setColorsCheckbox(data.colors);
  //     })
  //     .catch(()=>{
  //         toast.error('something error happened!, try again');
  //     })

  // }, [])

  const sizes = [
    { label: "L", value: "l", count: "10" },
    { label: "M", value: "m", count: "10" },
    { label: "S", value: "s", count: "10" },
    { label: "Xl", value: "xl", count: "10" },
    { label: "Xs", value: "xs", count: "10" },
  ];
  const colors = [
    { label: "Black", value: "black", count: "10" },
    { label: "Red", value: "red", count: "10" },
    { label: "Blue", value: "blue", count: "10" },
    { label: "Black", value: "black", count: "10" },
    { label: "Yellow", value: "yellow", count: "10" },
    { label: "Green", value: "green", count: "10" },
    { label: "Black", value: "black", count: "10" },
    { label: "Red", value: "red", count: "10" },
    { label: "Blue", value: "blue", count: "10" },
    { label: "Black", value: "black", count: "10" },
    { label: "Yellow", value: "yellow", count: "10" },
    { label: "Green", value: "green", count: "10" },
  ];

  return (
    <>
      <Container maxWidth="lg">
        <ToolbarBox>
          <Box
            sx={{
              width: { xs: "50%", md: "20%" },
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Button
              variant="text"
              sx={{
                color: "#878987",
                "&:hover": { color: "#b59677", background: "white" },
              }}
              startIcon={
                filterDivOpen ? <CloseOutlinedIcon /> : <TuneOutlinedIcon />
              }
              onClick={() => setFilterDivOpen((prev) => !prev)}
            >
              Filter
            </Button>
          </Box>

          <DisplayBox
            handleChangeDisplay={handleChangeDisplay}
            gridDisplay={gridDisplay}
            sx={{ display: { xs: "none", md: "flex" } }}
          />

          <Box
            sx={{
              width: { xs: "50%", md: "20%" },
              display: "flex",
              justifyContent: "right",
            }}
          >
            <FormControl
              sx={{
                width: "75%",
                "&:hover": {
                  "& .MuiInputBase-root fieldset": {
                    borderColor: "#DFDFDF",
                  },
                  "& .MuiSelect-select": {
                    color: "#b59677",
                  },
                },

                "& .Mui-focused": {
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "#DFDFDF",
                    borderWidth: "2px",
                  },
                },

                "& .MuiInputBase-root": {
                  height: "40px",
                  borderRadius: "10px",
                },
                "& .MuiSelect-select": {
                  color: "#878987",
                  fontFamily: "lato,sans-serif",
                  fontSize: "0.9rem",
                },

                "& fieldset": {
                  borderColor: "#DFDFDF",

                  "&:hover": {
                    borderColor: "#DFDFDF",
                  },
                },
                "& .MuiSelect-icon": {
                  color: "#878987",
                },
              }}
            >
              <Select
                value={searchSort}
                onChange={(e) => setSearchSort(e.target.value)}
              >
                <StyledMenuItem selected value={"featured"}>
                  Featured
                </StyledMenuItem>
                <StyledMenuItem value={"best selling"}>
                  Best selling
                </StyledMenuItem>
                <StyledMenuItem value={"alphabetically,a-z"}>
                  Alphabetically,A-Z
                </StyledMenuItem>
                <StyledMenuItem value={"alphabetically,z-a"}>
                  Alphabetically,Z-A
                </StyledMenuItem>
                <StyledMenuItem value={"price,low to hight"}>
                  Price,low to hight
                </StyledMenuItem>
                <StyledMenuItem value={"price,high to low"}>
                  Price,high to low
                </StyledMenuItem>
                <StyledMenuItem value={"date,old to new"}>
                  Date,old to new
                </StyledMenuItem>
                <StyledMenuItem value={"date,new to old"}>
                  Date,new to old
                </StyledMenuItem>
              </Select>
            </FormControl>
          </Box>
        </ToolbarBox>
        <AnimatePresence>
          {filterDivOpen && (
            <FilterDiv
              filterSearch={filterSearch}
              setFilterSearch={setFilterSearch}
              pricesSlider={pricesSlider}
              setPricesSlider={setPricesSlider}
              SizeCheckbox={SizeCheckbox}
              setSizeCheckbox={setSizeCheckbox}
              sizes={sizes}
              ColorsCheckbox={ColorsCheckbox}
              setColorsCheckbox={setColorsCheckbox}
              colors={colors}
              handleFilter={handleFilter}
            />
          )}
        </AnimatePresence>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </>
  );
};

export default ClothingFilter;
